import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceBehfaFilterGroupService } from 'src/app/Service/DeviceBehfaFilterGroup/DeviceBehfaFilterGroup.service';

@Component({
  selector: 'app-DeviceBehfaFilterGroupForm',
  templateUrl: './DeviceBehfaFilterGroupForm.component.html',
  styleUrls: ['./DeviceBehfaFilterGroupForm.component.scss']
})
export class DeviceBehfaFilterGroupFormComponent implements OnInit {

  @Input() inner_DeviceBehfaFilterGroup:General_Interface=Empty_General_Interface()

  @Output() outter_DeviceBehfaFilterGroup= new EventEmitter<number>();
  InProccessing: boolean = false
  modalRef_Delete: any;
  page:any

  constructor(
    private DeviceBehfaFilterGroup_Service: DeviceBehfaFilterGroupService,
    private modalService: BsModalService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {

    this.DeviceBehfaFilterGroupForm=new FormGroup({
      id :new FormControl(),
      title:new FormControl(null,Validators.required),
    })
    this.get_Form_title().setValue(this.inner_DeviceBehfaFilterGroup.title+'')

  }

  //#region  Form Add

  DeviceBehfaFilterGroupForm:FormGroup;

  get_Form_title(){
    return this.DeviceBehfaFilterGroupForm.get('title') as FormControl;
  }

  //#endregion

  OnSubmit() {

    var temp: General_Interface = Empty_General_Interface()
    temp.id = this.inner_DeviceBehfaFilterGroup.id
    temp.title = this.get_Form_title().value

   


    this.InProccessing=true
    this.DeviceBehfaFilterGroup_Service.addeditDeviceBehfaFilterGroup(temp).subscribe(
      data=>{
        this.InProccessing=false

        this.Alertify_Service.SuccessMessage(data.title+'')
        if(this.inner_DeviceBehfaFilterGroup.id==0)
          this.DeviceBehfaFilterGroupForm.reset()
      }
    )


  }


  onBack(){
    this.outter_DeviceBehfaFilterGroup.emit(-1);
  }

}
